import React from 'react';
import HeroSection from '../components/home/HeroSection';
import WhyTransaSection from '../components/home/WhyTransaSection';
import HowItWorksSection from '../components/home/HowItWorksSection';
import ServiceModelsSection from '../components/home/ServiceModelsSection';
import WhatWeCollectSection from '../components/home/WhatWeCollectSection';
import SavingsSection from '../components/home/SavingsSection';
import ServiceAreaSection from '../components/home/ServiceAreaSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import ComingSoonSection from '../components/home/ComingSoonSection';
import FinalCTASection from '../components/home/FinalCTASection';

const HomePage = () => {
  return (
    <main>
      <HeroSection />
      <SavingsSection />
      <WhyTransaSection />
      <HowItWorksSection />
      <ServiceModelsSection />
      <WhatWeCollectSection />
      <ServiceAreaSection />
      <TestimonialsSection />
      <ComingSoonSection />
      <FinalCTASection />
    </main>
  );
};

export default HomePage;
